import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import platformApi, { PLATFORM_TOKEN_KEY, platformErrorMessage } from '../../services/platformApi'
import './platform.css'

function OrganizationFormPage() {
  const navigate = useNavigate()
  const [form, setForm] = useState({
    legal_name: '',
    trade_name: '',
    document: '',
    slug: '',
    surface: 'erp_and_institutional',
  })
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const setField = (field) => (event) => {
    setForm((current) => ({ ...current, [field]: event.target.value }))
  }

  const handleSubmit = async (event) => {
    event.preventDefault()
    setError('')
    setLoading(true)
    try {
      const { data } = await platformApi.post('/api/platform/organizations', {
        ...form,
        slug: form.slug.trim().toLowerCase(),
      })
      navigate(`/plataforma/${data.organization.id}`, { replace: true })
    } catch (err) {
      if (err.response?.status === 401) {
        localStorage.removeItem(PLATFORM_TOKEN_KEY)
        navigate('/plataforma/login', { replace: true })
        return
      }
      setError(platformErrorMessage(err, 'Não foi possível cadastrar'))
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="platform-page">
      <header className="platform-topbar">
        <div>
          <h1>Nova organização</h1>
          <p>O cadastro fica pendente. As tabelas só nascem quando você autorizar.</p>
        </div>
        <Link className="platform-button-secondary" to="/plataforma">Voltar</Link>
      </header>
      <main className="platform-body">
        {error ? <p className="platform-error">{error}</p> : null}
        <form className="platform-card platform-form" onSubmit={handleSubmit}>
          <label>
            Razão social
            <input value={form.legal_name} onChange={setField('legal_name')} required />
          </label>
          <label>
            Nome fantasia
            <input value={form.trade_name} onChange={setField('trade_name')} />
          </label>
          <label>
            CNPJ
            <input value={form.document} onChange={setField('document')} />
          </label>
          <label>
            Identificador
            <input
              value={form.slug}
              onChange={setField('slug')}
              placeholder="lar-idosos"
              required
            />
          </label>
          <label>
            Site público
            <select value={form.surface} onChange={setField('surface')}>
              <option value="erp_and_institutional">ERP e vitrine institucional</option>
              <option value="erp_and_storefront">ERP e loja</option>
            </select>
          </label>
          <button className="platform-button" type="submit" disabled={loading}>
            {loading ? 'Salvando…' : 'Cadastrar como pendente'}
          </button>
        </form>
      </main>
    </div>
  )
}

export default OrganizationFormPage
